module.exports = __webpack_public_path__ + "media/images/ui__textCrossLight-71d198d69e78dd63696da1e0de8251cb.png";